var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDisplay === 1)?_c('Detail',{attrs:{"detailId":_vm.detailId},on:{"customEvent":function($event){return _vm.$emit('customEvent', $event)}}}):_vm._e(),(_vm.isDisplay === 2)?_c('History',{on:{"customEvent":function($event){return _vm.$emit('customEvent', $event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }